export const actionTypes = {
    UPDATE_SEARCH_QUERY: 'UPDATE_SEARCH_QUERY',
    UPDATE_SEARCH_PARAMS: 'UPDATE_SEARCH_PARAMS',
    UPDATE_SEARCH_RESULTS: 'UPDATE_SEARCH_RESULTS',
    UPDATE_CURR_PAGE_NUMBER: 'UPDATE_CURR_PAGE_NUMBER',
    UPDATE_TOTAL_PAGES_NUMBER: 'UPDATE_TOTAL_PAGES_NUMBER',
    UPDATE_STATUS: 'UPDATE_STATUS'
}